import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "code-view" }
const _hoisted_2 = ["data-clipboard-text"]

import { NTree, NCode, NEl, NIcon, useMessage } from "naive-ui";
import { useMainStore } from "@/store/main";
import { onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import selectedFile from "@/utils/findDefaultSelect";
import { ContentCopyOutlined } from "@vicons/material";
import ClipboardJS from "clipboard";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useMainStore();
const router = useRouter();
const message = useMessage();
if (store.directory.length < 1) {
  router.replace("/");
}

const defaultSelectNode = ref<string>("");

defaultSelectNode.value = selectedFile(store.directory);

const code = reactive<{ code: string; language: string }>({
  code: "",
  language: "",
});
const handleSelectFile = async (keys: Array<string | number>) => {
  const key = keys[0];
  const file = store.files[key];
  let fileType = "txt";
  if (file.dir) return;
  const r = /.+\/.*?\.(.*?)$/.exec(key as string);
  if (r !== null) {
    fileType = r[1];
  }
  code.code = await file.async("string");
  code.language = fileType;
};
onMounted(() => {
  const clipboard = new ClipboardJS(".code-view-copy");
  clipboard.on("success", () => {
    message.info("复制成功");
  });
});
if (defaultSelectNode.value !== "") {
  handleSelectFile([defaultSelectNode.value]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NEl), {
      tag: "div",
      style: {"border":"1px solid var(--border-color)","height":"100%"},
      class: "code-view-directory"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NEl), {
          tag: "div",
          style: {"border-bottom":"1px solid var(--border-color)","padding":"10px","font-weight":"600"},
          class: "code-view-filename"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(store).artifactId) + ".zip ", 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(NTree), {
          data: _unref(store).directory,
          "default-expanded-keys": [_unref(store).artifactId + '/'],
          "default-selected-keys": [defaultSelectNode.value],
          onUpdateSelectedKeys: handleSelectFile
        }, null, 8, ["data", "default-expanded-keys", "default-selected-keys"])
      ]),
      _: 1
    }),
    _createVNode(_unref(NEl), {
      tag: "div",
      style: {"border":"1px solid var(--border-color)","height":"100%","padding":"0 10px"},
      class: "code-view-code"
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "code-view-copy",
          "data-clipboard-text": _unref(code).code
        }, [
          _createVNode(_unref(NIcon), {
            size: "20",
            color: "#bcbcbc"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ContentCopyOutlined))
            ]),
            _: 1
          })
        ], 8, _hoisted_2), [
          [_vShow, _unref(code).code]
        ]),
        (_unref(code).code)
          ? (_openBlock(), _createBlock(_unref(NCode), {
              key: 0,
              code: _unref(code).code,
              language: _unref(code).language
            }, null, 8, ["code", "language"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})